import { html } from 'lit';
const TemplateOutline =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M9.018 3.546c.472-.916 1.786-.9 2.236.026l2.478 5.1a.75.75 0 0 1-1.35.656l-2.258-4.65-2.4 4.665a.75.75 0 0 1-1.334-.686zM15.5 5.75c-.44 0-.86.075-1.25.213a.75.75 0 1 1-.5-1.414 5.25 5.25 0 0 1 6.968 4.369.75.75 0 0 1-1.49.164A3.75 3.75 0 0 0 15.5 5.75"/><path fill='currentColor' fill-rule="evenodd" d="M4.5 8.75a.75.75 0 0 0-.75.75v4.998l.722-2.6A2.25 2.25 0 0 1 6.64 10.25h12.887a2.25 2.25 0 0 1 2.168 2.852l-1.667 6a2.25 2.25 0 0 1-2.168 1.648H4.5a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 7.25H5a.75.75 0 0 1 0 1.5zm13.36 10.5H4.973a.75.75 0 0 1-.722-.95l1.666-6a.75.75 0 0 1 .723-.55h12.887a.75.75 0 0 1 .722.95l-1.666 6a.75.75 0 0 1-.723.55" clip-rule="evenodd"/>
  </svg>
`;
export default TemplateOutline;
